module.exports = __webpack_public_path__ + "static/media/item_38_1.2097f312.png";